import fn from "react-keyed-flatten-children";

export const flattenChildren = fn;
